
const ua = navigator.userAgent;

const isIos = !!ua.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
const isAdr = ua.indexOf('Android') > -1 || ua.indexOf('Linux') > -1;

const inApp = ua.indexOf('zxb') >= 0 ? true : false;

const isWx = !!ua.match(/MicroMessenger/i);

const isMQB = ua.indexOf('MQQBrowser') > -1 ? true : false;

const qq_store_link = 'http://a.app.qq.com/o/simple.jsp?pkgname=com.peopletech.news';

const artTypes = {
    '1': 'normal',
    '3': 'video',
    '4': 'audio',
    '5': 'image'
};

export {
    isIos,
    isAdr,
    inApp,
    isWx,
    isMQB,
    apk_down_link,
    qq_store_link,
    artTypes
}



// WEBPACK FOOTER //
// ./src/constants/index.js